import React, { Component } from 'react';
import { connect } from 'react-redux';
import './Contact.css';
import { googleMapApiKey } from '../../config/config';
import { isMobile } from '../../lib/util';
import Breadcrumb from '../../components/Breadcrumb';
import ContactMap from '../../components/ContactMap';
import ScrollToTopOnMount from '../../components/ScrollToTopOnMount';
import FontAwesomeIcon from '@fortawesome/react-fontawesome';
import faMap from '@fortawesome/fontawesome-free-solid/faMap';

class Contact extends Component {
  // constructor(props) {
  //   super(props);
  //   this.state = {
  //     contacts: [],
  //   };
  // }

  render() {
    return (
      <section className="section">
        <ScrollToTopOnMount />
        <div className="contact container">
          <Breadcrumb {...this.props} />
          <div className="outter-container">
            <div className="inner-container">
              {this.props.contacts.slice().reverse().map((elem, idx) => (
                <div className="contact-wrapper" key={`contact-${idx}`}>
                  <div className="title">{elem.title}</div>
                  <div className="columns">
                    <div className="column is-three-fifths">
                      <ContactMap
                        isMarkerShown
                        googleMapURL={`https://maps.googleapis.com/maps/api/js?v=3.exp&libraries=geometry,drawing,places&key=${googleMapApiKey}`}
                        loadingElement={<div className="map-container map-container--loading" />}
                        containerElement={<div className="map-container" />}
                        mapElement={<div className="map" />}
                        marker={{ lat: elem.map_lat, lng: elem.map_lng }}
                      />
                    </div>

                    <div className="column is-two-fifths contact-info">
                      <div className="address">
                        <div className="description">地址</div>
                        <div className="content">{elem.address}</div>
                        {isMobile() && (
                          <a
                            href={`https://www.google.com/maps/place/${elem.address}`}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="open-map-link"
                          >
                            <FontAwesomeIcon icon={faMap} size="xs"/>
                            <span>開啟地圖</span>
                          </a>
                        )}
                      </div>
                      <div className="phone">
                        <div className="description">電話</div>
                        <div className="content">{elem.phone}</div>
                      </div>
                      <div className="fax">
                        <div className="description">傳真</div>
                        <div className="content">{elem.fax}</div>
                      </div>
                      <div className="opening-hours">
                        <div className="description">營業時間</div>
                        <div className="content">{elem.opening_hours}</div>
                      </div>
                      <div className="email">
                        <div className="description">服務信箱</div>
                        <div className="content">{elem.email}</div>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>
    );
  }
}

const mapStateToProps = state => ({
  contacts: state.contacts,
});

export default connect(mapStateToProps)(Contact);



// WEBPACK FOOTER //
// ./src/containers/page/Contact.js